<template>
  <div :class="{info: true, open: open, mobile: mobile()}">
    <img src="@/assets/christmas/closeIcon.svg" class="closeIcon" @click="$emit('close')">

    <div v-if="! mobile()" class="menu">
      <div v-for="(item, index) in info"
           :class="{menuItem: true, selected: index === active, separator: item.lastOfType}"
           @click="activate(index)">
        {{ item.title }}
      </div>
    </div>
    <div id="infoContent" class="content clearfix">
      <InfoContent
          ref="article-0"
          :index="0"
          :info="info"
          :activeIndex="active">
        Ja, richtig - Prophezeiungen! Das mag komisch klingen, ist aber so: schon über <b>700 Jahre vor der
        Geburt</b> des Messias kündigten Propheten viele <b>Details</b> an, die seine Person und sein Leben
        betreffen.
        Einige davon verblüffen durch ihre Entsprechung im Leben von Jesus Christus so sehr, dass sie zwei Arten
        von Reaktionen hervorgerufen haben. Eine Gruppe sieht die erfüllten Prophezeiungen als starkes <b>Argument
        für die Authentizität der Bibel</b>, die andere vermutete eine Fälschung. Kritiker nahmen also lange an,
        dass diese Prophezeiungen erst nach Jesu Geburt geschrieben und somit gefälscht worden waren.
        <br>
        Spannenderweise fanden Archäologen vor etwa 70 Jahren Schriftrollen in einer Höhle (Qumran-Rollen) beim
        Toten Meer, welche viele Prophezeiungen beinhalten, deren Echtheit früher angezweifelt wurde (z.B.
        Jesaja 53). Diese wurden jedoch <b>wissenschaftlich datiert</b> und sind seitdem <b>nachweislich vor der
        Geburt von Jesus</b> aufgeschrieben worden. [1].
        <br>
        Wir haben drei dieser Prophezeiungen herausgesucht, damit du dir selbst ein Bild machen kannst:
        <br>
        <b>Jesus wird in Bethlehem geboren:</b><br>
        "Und du, <b>Bethlehem</b>-Ephrata, du bist zwar gering unter den Hauptorten von Juda; aber aus dir soll
        mir hervorkommen, der Herrscher über Israel werden soll, dessen Hervorgehen von Anfang, von den Tagen
        der Ewigkeit her gewesen ist." (<a href="https://www.bibleserver.com/SLT/Micha5,1" target="_blank">Micha
        5,1</a>)
        <br>
        <b>Jesus wird gekreuzigt:</b><br>
        "Doch er wurde um unserer Übertretungen willen <b>durchbohrt</b>, wegen unserer Missetaten zerschlagen;
        die Strafe lag auf ihm, damit wir Frieden hätten, und durch seine <b>Wunden</b> sind wir geheilt
        worden." (<a href="https://www.bibleserver.com/SLT/Jesaja53,5" target="_blank">Jesaja 53,5</a>)
        <br>
        <b>Jesus wird gefoltert aber wehrt sich nicht:</b>
        <br>
        "Er wurde <b>misshandelt</b>, aber er beugte sich und <b>tat seinen Mund nicht auf</b>, wie ein
        <b>Lamm</b>, das zur Schlachtbank geführt wird, und wie ein Schaf, das verstummt vor seinem Scherer und
        seinen Mund nicht auftut." (<a href="https://www.bibleserver.com/SLT/Jesaja53,7" target="_blank">Jesaja
        53,7</a>)
        <br>
        Falls es dich interessiert, kannst du dir zum Beispiel eine <a
          href="https://wersglaubt.at/Prophezeiungen%20Wahrscheinlichkeiten.pdf"
          target="_blank">ausführliche Auflistung von Prophezeiungen über Jesus</a> anschauen, oder dir <a
          href="https://www.bibleserver.com/SLT/Jesaja53" target="_blank">Jesaja 53</a> ganz durchlesen - ein
        sehr beeindruckendes Kapitel!
        <br><br>
        [1]: <a href="https://de.wikipedia.org/wiki/Schriftrollen_vom_Toten_Meer" target="_blank">Schriftrollen
        vom Toten Meer - Wikipedia</a>
      </InfoContent>
      <InfoContent
          ref="article-1"
          :index="1"
          :info="info"
          :activeIndex="active">
        Im Vergleich zum Neuen Testament der Bibel geben nicht-christliche Quellen keinen detaillierten
        Aufschluss über das Leben von Jesus Christus. Was sie aber sehr wohl tun: sie bestätigen es. Robert
        Stein, ein Professor für Neutestamentliche Interpretation in Lousville Kentucky, stellt fest, dass aus
        den säkularen Quellen folgende Aussagen über Jesus hervorgehen:
        <br>
        Jesus war eine historische belegte reale Person und lebte in Palästina im ersten Jahrhundert unserer
        Zeitrechnung. Die jüdische Führungsschicht war maßgeblich für den Tod von Jesus verantwortlich und er
        wurde von den Römern unter der Regierung von Statthalter Pontius Pilatus <b>gekreuzigt</b>. Außerdem
        geben die Quellen Aufschluss darüber, dass das Wirken Jesu in Verbindung einer <b>Art Zauberei und
        Wundertaten</b> stand.

        Edwin Yamauchi, Professor für Geschichte an der Universität in Miami, gibt an, dass aus den säkularen
        Quellen hervorgeht, dass:

        <ul>
          <li>Jesus ein <b>jüdischer Lehrer</b> war.</li>
          <li><b>viele Leute glaubten</b>, dass er <b>böse Geister austreiben konnte</b> und <b>Wunder
            vollbracht</b> hat.
          </li>
          <li>Jesus unter der Kaiserherrschaft von Tiberius <b>von den jüdischen Führern abgelehnt</b> und <b>unter
            Pontius Pilatus gekreuzigt wurde.</b></li>
          <li>Jesu Anhänger trotz der demütigenden Hinrichtung <b>davon überzeugt waren, dass er am Leben –
            also auferstanden – war.</b></li>
          <li><b>seine Anhängerschaft</b> sich von <b>Palästina bis nach Rom hin ausbreitete.</b></li>
          <li>bereits bis zum Beginn des Zweiten Jahrhunderts n. Chr. Menschen aus Stadt und Land sowie
            Angehörige beider Geschlechter und aller Schichten <b>Jesus als Gott verehrten.</b></li>
        </ul>

        Diese außerbiblischen Belege fordern uns heraus, uns Fragen über Jesus zu stellen. War er ein
        Verrückter? War er ein Rebellenführer? War er ein Heiler? Und vor allem: Warum tauchen kurze Zeit nach
        seinem Tod unzählige Augenzeugen auf, die davon überzeugt sind, dass er wieder auferstanden ist? Diese
        Gewissheit hat zur Folge, dass sie einige Jahre später auch im Angesicht des Todes zu ihren Aussagen
        stehen. Die erste Christenverfolgung [1] teilt ihnen das Märtyrer-Los zu. Jesu Zeitgenossen bleiben bei
        dem, was sie nach ihrer Aussage mit eigenen Augen gesehen haben. Es hat sie derart beeindruckt, dass
        ihre Überzeugung mehr als der irdische Vorteil wiegt.


        <br>
        [1] <a href="https://de.wikipedia.org/wiki/Christenverfolgungen_im_Römischen_Reich#Urchristentum"
               target="_blank">Christenverfolgung im Urchristentum - Wikipedia</a>

      </InfoContent>
      <InfoContent
          ref="article-2"
          :index="2"
          :info="info"
          :activeIndex="active">
        Jungfrauengeburt? Absurd! Die Wissenschaft erklärt eindeutig, dass es nicht möglich ist, dass eine
        Jungfrau schwanger wird. Wirklich? Was sie genau genommen sagt ist, dass es <b>nicht den von der
        Wissenschaft erkennbaren Regeln der Natur entspricht, dass eine Jungfrau schwanger wird.</b> Ein <b>Wunder
        ist diesen Regeln jedoch nicht unterworfen</b>, weil es per Definition ein Vorkommnis ist, das sich
        nicht so verhält, wie die Naturgesetzte es vermuten lassen. Eine Frage an die Logik: Sollte es für einen
        Gott, der Himmel und Erde erschaffen hat, ein Problem sein, seinen Sohn durch ein Wunder auf die Welt zu
        bringen?
        <br>
        Wenn man die Bibel zu Rate zieht, zeigt sich ein aufschlussreicheres Bild. Die Jungfrauengeburt <b>soll
        auch im biblischen Kontext nichts Normales darstellen</b>, sondern eben - <b>heute wie damals</b> -
        Verwunderung auslösen. (Die Menschen wussten auch damals sehr wohl, wie eine Schwangerschaft zustande
        kommt.) Die außergewöhnliche Geburt wurde schon im Vorhinein von Gott angekündigt, um den Menschen zu
        zeigen, dass der dadurch gezeugte Mensch eben kein gewöhnlicher Mensch ist. „Darum wird euch der Herr
        selbst ein Zeichen geben: Siehe, die Jungfrau wird schwanger werden und einen Sohn gebären und wird ihm
        den Namen Immanuel geben.“ (<a href="https://www.bibleserver.com/SLT/Jesaja7,14" target="_blank">Jesaja
        7,14</a>)

      </InfoContent>
      <InfoContent
          ref="article-3"
          :index="3"
          :info="info"
          :activeIndex="active">
        Ob der Ort, an dem Jesus auf die Welt kam, wirklich ein Stall war, ist eigentlich unbekannt. In der
        Darstellung der alpenländischen Krippenszene wird es zumeist so gezeigt. Das Wort „Stall“ als solches
        kommt in der Weihnachtsgeschichte aber nicht vor. Man schließt darauf, weil der Evangelist Lukas in
        seinem Bericht über die Geburt Jesu erklärt, dass die Hirten das Kind in einer Krippe liegend vorfanden.
        Die Krippe bezeichnet einen Futtertrog für Nutztiere. Auch die Engel, die die Hirten auf dem Feld über
        die Geburt des Retters informieren, beschreiben das Kind als in einer Krippe liegend.
        <br>
        In römischen Berichten aus dem ersten Jahrhundert nach Christus wird angenommen, dass Jesus in einer
        Höhle zur Welt kam. Damals brachte man die Tiere in Höhlen in Sicherheit. Solch ein Unterstand für Tiere
        war sicherlich unhygienisch und unpassend für ein neugeborenes Kind. Ob nun Höhle oder Stall: Die Bibel
        berichtet uns, dass Jesus als Sohn Gottes neben Tieren zur Welt kam, weil bei den Menschen kein Platz
        für ihn war. Der Messias, auf den die jüdische Welt wartete, bezog also nicht mit Prunk und Macht einen
        angemessenen Thronsaal, sondern gesellte sich von Anfang an zu den Verstoßenen und Geringen.
      </InfoContent>
      <InfoContent
          ref="article-4"
          :index="4"
          :info="info"
          :activeIndex="active">
        Wie kommt man in den Himmel? Die gebräuchliche Meinung dazu ist: Führe ein einigermaßen moralisches
        Leben und versuche dein Verhalten laufend zu verbessern. Das wird reichen. Hoffentlich. Wer so denkt,
        hat eine ungewisse Hoffnung auf den Himmel. Das Problem dabei ist, dass dieses Denken bei so vielen
        Menschen vorherrscht. „Wenn du je in den Himmel kommen willst”, argumentieren sie, „ist es ganz klar,
        dass du gut sein musst. Wenn du nicht gut bist, wirst du bestimmt nicht in den Himmel kommen!” Dieser
        Gedanke ist so tief verwurzelt, dass sie keine Notwendigkeit sehen, das Neue Testament zu lesen, um
        herauszufinden, was es wirklich sagt. Sie nehmen einfach an, dass darin steht, was sie erwarten.
        Tatsache ist aber, dass das Neue Testament genau das Gegenteil von dieser landläufigen Sicht lehrt. Der
        Ausdruck „Errettung“ ist nicht einfach ein anderer Name für eine bestimmte Moral, die wir einhalten
        müssen, um uns die Annahme bei Gott und einen Platz in seinem Himmel zu verdienen. „Errettung“ meint
        genau das, was es wörtlich aussagt.
        <br>
        Gott rettet. Wovor? Vor dem Schuldspruch im großen Gericht am Ende der Zeiten. Dieser Schuldspruch wird
        jeden Menschen treffen, weil jeder Mensch gesündigt hat. Und das hat tragische Folgen für die Ewigkeit.
        Die Grundbedeutung ist die richtige Bedeutung. Es handelt sich um eine Rettungsaktion, die Gott für jene
        unternimmt, die sich
        niemals selbst retten können – auch wenn sie alles versuchten. Wir können uns den Himmel niemals durch
        gute Taten verdienen. Das Neue Testament erklärt wiederholt und deutlich, dass Errettung nicht durch unsere
        guten Taten geschieht: Sie ist das Geschenk Gottes an solche, die nie dafür bezahlen oder es sich verdienen
        könnten. In den Himmel kommt man nur durch ein geschenktes Ticket, das man sich bei Gott abgeholt hat.
      </InfoContent>
      <InfoContent
          ref="article-5"
          :index="5"
          :info="info"
          :activeIndex="active">
        Ein König wird geboren - üblicherweise ist das mit Besuch von viel Prominenz verbunden. Anders bei
        Jesus: die ersten, die ihn zu Gesicht bekamen, waren ganz einfache Leute - Hirten. Zur damaligen Zeit
        war das ein sehr geringer und anstrengender Beruf, der heute nicht unbedingt die erste Wahl bei der
        Jobsuche wäre. In der Bibel lesen wir, dass den Hirten die frohe Botschaft über Jesu Geburt von Engeln
        verkündigt wurde (<a href="https://www.bibleserver.com/SLT/Lukas2,8-20" target="_blank">Lukas 2,8-20</a>).
        <br>
        Warum sorgt Gott dafür, dass zuerst solch einfache Personen von der guten Nachricht erfahren, und nicht
        etwa die vornehmen jüdischen Gelehrten? Ist es Gott egal, dass die Hirten keine Ausbildung haben? Ja. In
        der Bibel zeigt sich tatsächlich immer wieder, dass Gott niemanden geringachtet und dass ihn alle
        Menschen kennenlernen können. Somit ist auch die gute Nachricht von der Geburt des Erlösers für alle
        gleichermaßen relevant. Als erwachsener Mann erklärt Jesus einmal:
        <br>
        "Denn Gott hat der Welt seine Liebe dadurch gezeigt, dass er seinen einzigen Sohn für sie hergab, damit
        jeder, der an ihn glaubt, das ewige Leben hat und nicht verloren geht." (<a
          href="https://www.bibleserver.com/NGÜ/Johannes3,16" target="_blank">Johannes 3,16</a>)<br>
        Gott möchte also, dass <b>jeder gerettet wird</b>, ganz egal ob arm oder reich - also auch du und ich!
        Ist das nicht eine gute Nachricht?
      </InfoContent>
      <InfoContent
          ref="article-6"
          :index="6"
          :info="info"
          :activeIndex="active">
        "Sie haben gewonnen! Wir gratulieren zum Hauptgewinn!" Kaum jemand von uns erlebt diesen Moment.
        Millionen regnen auf den Glückspilz. Was für eine gute Nachricht! Aber was die Hirten in der Nacht, als
        Jesus geboren wurde, von den Engeln erfuhren, ist eigentlich eine noch bessere Nachricht - und das nicht
        nur für ganz wenige "Glückspilze", sondern für jeden Menschen, der sich angesprochen fühlt.
        <br>
        "Der Retter ist geboren", sagt der Engel zu den Hirten. Jetzt können Menschen gerettet werden - und zwar
        nicht einfach, damit sie in dieser Welt mehr Geld haben. Wer diesen Retter hat, der hat Zutritt zu einer
        herrlichen und ewigen Welt, dem Himmel. Die schönsten unserer irdischen Urlaubsressorts verblassen gegen
        die Herrlichkeit und das Glück, das Menschen in der ewigen Gemeinschaft mit einem gütigen und
        großzügigen Gott erleben werden.
        <br>
        Und das Beste: Es gibt keinen Haken. Kein "war ich eh gut genug?", keinen Zwang. Jesus ist als Retter
        auf die Erde gekommen, um später am Kreuz die Strafe auf sich zu nehmen, die eigentlich dich und mich
        treffen müsste. Wer das für sich annimmt, der hat den Hauptgewinn getroffen! Jesus sagt:br>
        "Wahrlich, wahrlich, ich sage euch: Wer mein Wort hört und dem glaubt, der mich gesandt hat, der hat
        ewiges Leben und kommt nicht ins Gericht, sondern er ist vom Tod zum Leben hindurchgedrungen." (<a
          href="https://www.bibleserver.com/SLT/Johannes5,24" target="_blank">Johannes 5,24</a>)
      </InfoContent>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import BasicComponent from "@/components/BasicComponent.js";
import {Prop} from "vue-property-decorator";
import InfoContent from "@/components/christmas/info/InfoContent";
import VueScrollTo from "vue-scrollto";

@Component({
  components: {InfoContent}
})
export default class Info extends BasicComponent {

  @Prop(Boolean) open;
  @Prop(Array) infoArray;

  data() {
    return {
      active: 0,
    };
  }

  mounted() {
    this.register();
  }

  activate(index) {
    this.$data.active = index;
    document.getElementById("infoContent").scrollTop = 0;

    this.trackEvent( 'Weihnachten - Zusatzinfos aufgerufen', this.info[index].title);
    this.trackPage("Weihnachten Zusatzinfos - " + this.info[index].title);
  }

  openArticles(articles) {
    if (articles == null || articles.length === 0) return;
    this.activate(articles[0]);
    document.getElementById("infoContent").classList.remove("makeScrollable");
    for (let key of Object.keys(this.$refs)) {
      if (!key.startsWith("article-")) continue;
      this.$refs[key].setActive(false);
    }
    for (let article of articles) {
      //if (article !== articles[articles.length - 1]) continue; // only open last one of section for now
      this.$refs["article-" + article].setActive(true);
    }
    this.$nextTick(() => {
      document.getElementById("infoContent").scrollTop = 0;
    });
  }

  get info() {
    return this.infoArray;
  }


}
</script>
<style scoped lang="scss">
@import "@/stylesheets/Christmas.scss";

.info {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  transform: translateX(120%);
  transition: 1s ease-in-out;
  z-index: 2500;
  padding: 30px;
  box-sizing: border-box;

  background-color: white;

  &.open {

    transform: none;
  }

  $menuWidth: 300px;

  .menu {
    display: inline-block;
    height: 100%;
    width: $menuWidth;
    float: left;

    .menuItem {
      padding: 10px;
      color: #00033699;
      text-align: left;

      &:hover {
        cursor: pointer;
      }

      &.selected {
        color: #000336;
      }

      &.separator {
        &::after {
          content: " ";
          display: block;
          margin-top: 20px;
          width: calc(100% - 40px);
          border-bottom: 1px solid #707070;
        }
      }
    }
  }

  .content {
    display: inline-block;
    height: 100%;
    width: calc(100% - #{$menuWidth});
    float: right;
    padding-top: 10px;
    overflow-y: scroll !important;
  }

  .closeIcon {
    position: absolute;
    top: 15px;
    right: 15px;
    height: 15px;
    //padding: 10px;

    &:hover {
      cursor: pointer;
    }
  }

}

.info.mobile {
  width: 100%;
  left: 0;

  .content {
    width: 100%;
  }

}

</style>

<style lang="scss">

.makeScrollable {
  -webkit-overflow-scrolling: touch;
}

</style>
